import type { ValueEditorOptions } from '../kp-value-editor/types';
import type {ForceSetting, KpValueEditorForceSettingsMergeStrategy} from './types';
import {ALL_TYPES, DEFAULT_MERGE_STRATEGY} from './types';
import {merge} from 'lodash';
import type {ValueEditorTypeOrAlias} from '../types';


export class ForceSettingsOptionsMerger {

    constructor(private settings: Map<ValueEditorTypeOrAlias, Omit<ForceSetting, 'type'>>) {}

    public mergeOptionsForType<OPTIONS extends ValueEditorOptions = ValueEditorOptions>(type: ValueEditorTypeOrAlias, options: OPTIONS): OPTIONS {
        const mergeStrategy = this.settings.get(type)?.strategy ?? DEFAULT_MERGE_STRATEGY;
        const mergeFunction = this.getMergeFunctionByStrategy(mergeStrategy);
        return mergeFunction({}, options, this.getOptionsForTypeOrEmpty(type, mergeStrategy));
    }

    private getOptionsForTypeOrEmpty<OPTIONS extends ValueEditorOptions>(type: ValueEditorTypeOrAlias, mergeStrategy: KpValueEditorForceSettingsMergeStrategy): OPTIONS {
        const mergeFunction = this.getMergeFunctionByStrategy(mergeStrategy);
        return mergeFunction({}, (this.settings.get(ALL_TYPES)?.options ?? {}), this.settings.get(type)?.options ?? {}) as OPTIONS;
    }

    private getMergeFunctionByStrategy(mergeStrategy: KpValueEditorForceSettingsMergeStrategy) {
        return mergeStrategy === 'merge' ? merge : Object.assign;
    }
}